import onGetAllocatedClients from './onGetAllocatedClients';
import onGetTeamMembersLocation from './onGetTeamMembersLocation';

export default {
  onGetTeamMembersLocation,
  onGetAllocatedClients,
};
